export default "__VITE_ASSET__d24af6b6__"